import type { TSetState } from "@/types";

export const renderGame = (content: HTMLDivElement, setState: TSetState) => {
  content.innerHTML = `
    <div class="text-center space-y-4 flex flex-col items-center">
      <h1 class="text-2xl font text-shadow-md text-fuchsia-600">Teď musíš chytit srdíčka 🤭</h1>
      <canvas id="gameCanvas" class="bg-white rounded-2xl h-56 sm:h-full w-full shadow-lg aspect-square"></canvas>     
      <p id="gameScore" class="text-xl text-shadow-md text-pink-600"></p>
    </div>
  `;

  const canvas = document.querySelector<HTMLCanvasElement>("#gameCanvas")!;
  const ctx = canvas.getContext("2d")!;
  const scoreEl = document.querySelector("#gameScore")!;

  const heartSize = 25;
  const velocity = 5;
  const targetScore = 30;

  let hearts: Array<{ x: number; y: number; speed: number }> = [];
  let score = 0;

  canvas.addEventListener("click", (e) => {
    const rect = canvas.getBoundingClientRect();

    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    const mx = (e.clientX - rect.left) * scaleX;
    const my = (e.clientY - rect.top) * scaleY;

    hearts = hearts.filter((h) => {
      const dx = h.x - mx;
      const dy = h.y - my;
      const distance = Math.sqrt(dx * dx + dy * dy);

      const hitRadius = heartSize * 0.7 + h.speed * 6;
      const hit = distance < hitRadius;
      if (hit) score++;

      return !hit;
    });
  });

  const resizeCanvas = () => {
    const rect = canvas.getBoundingClientRect();

    canvas.width = rect.width;
    canvas.height = rect.height;
  };

  const update = () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.font = `${heartSize}px Arial`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    hearts.forEach((h) => {
      h.y += h.speed;
      ctx.fillText("❤️", h.x, h.y);
    });

    hearts = hearts.filter((h) => h.y < canvas.height + 80);
    scoreEl.textContent = `Množstí lásky: ${score} / ${targetScore}`;

    if (score >= targetScore) {
      setState("envelope");

      return;
    }

    requestAnimationFrame(update);
  };

  setInterval(() => {
    hearts.push({
      x: Math.random() * (canvas.width - 30),
      y: -30,
      speed: velocity / 2 + Math.random() * velocity
    });
  }, 800);

  window.addEventListener("resize", resizeCanvas);

  resizeCanvas();
  update();
};
